/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as authRegisterImport } from './routes/(auth)/register'
import { Route as authLoginImport } from './routes/(auth)/login'
import { Route as appDashboardImport } from './routes/(app)/dashboard'
import { Route as publicPublicIndexImport } from './routes/(public)/_public/index'
import { Route as appInvoiceTemplateIndexImport } from './routes/(app)/invoice-template/index'
import { Route as appDashboardIndexImport } from './routes/(app)/dashboard/index'
import { Route as publicPublicFeaturesImport } from './routes/(public)/_public/features'
import { Route as publicPublicDocsImport } from './routes/(public)/_public/docs'
import { Route as appDashboardTodosImport } from './routes/(app)/dashboard/todos'
import { Route as appDashboardSettingsImport } from './routes/(app)/dashboard/settings'
import { Route as appDashboardInvoicesImport } from './routes/(app)/dashboard/invoices'
import { Route as appDashboardTodosIndexImport } from './routes/(app)/dashboard/todos/index'
import { Route as appDashboardTemplateCustomizerIndexImport } from './routes/(app)/dashboard/template-customizer/index'
import { Route as appDashboardShippingRatesIndexImport } from './routes/(app)/dashboard/shipping-rates/index'
import { Route as appDashboardSettingsIndexImport } from './routes/(app)/dashboard/settings/index'
import { Route as appDashboardInvoicesIndexImport } from './routes/(app)/dashboard/invoices/index'
import { Route as appDashboardInvoiceTemplateIndexImport } from './routes/(app)/dashboard/invoice-template/index'
import { Route as appDashboardCustomersIndexImport } from './routes/(app)/dashboard/customers/index'
import { Route as appDashboardCompanyDetailsIndexImport } from './routes/(app)/dashboard/company-details/index'
import { Route as appDashboardTodosNewImport } from './routes/(app)/dashboard/todos/new'
import { Route as appDashboardSettingsUserProfileImport } from './routes/(app)/dashboard/settings/user-profile'
import { Route as appDashboardSettingsNumberSchemasImport } from './routes/(app)/dashboard/settings/number-schemas'
import { Route as appDashboardSettingsChangePasswordImport } from './routes/(app)/dashboard/settings/change-password'
import { Route as appDashboardSettingsAppSettingsImport } from './routes/(app)/dashboard/settings/app-settings'
import { Route as appDashboardInvoicesNewImport } from './routes/(app)/dashboard/invoices/new'
import { Route as appDashboardCustomersNewImport } from './routes/(app)/dashboard/customers/new'
import { Route as appDashboardCustomersIdIndexImport } from './routes/(app)/dashboard/customers/$id/index'
import { Route as appDashboardTodosEditIdImport } from './routes/(app)/dashboard/todos/edit/$id'
import { Route as appDashboardTodosDetailIdImport } from './routes/(app)/dashboard/todos/detail/$id'
import { Route as appDashboardInvoicesEditIdImport } from './routes/(app)/dashboard/invoices/edit/$id'
import { Route as appDashboardInvoiceTemplateDesignerNewImport } from './routes/(app)/dashboard/invoice-template/designer.new'
import { Route as appDashboardInvoiceTemplateDesignerTemplateIdImport } from './routes/(app)/dashboard/invoice-template/designer.$templateId'
import { Route as appDashboardCustomersEditIdImport } from './routes/(app)/dashboard/customers/edit/$id'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()
const appDashboardSettingsInvoiceTemplatesLazyImport = createFileRoute(
  '/(app)/dashboard/settings/invoice-templates',
)()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const authRegisterRoute = authRegisterImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const appDashboardRoute = appDashboardImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicIndexRoute = publicPublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)

const appInvoiceTemplateIndexRoute = appInvoiceTemplateIndexImport.update({
  id: '/(app)/invoice-template/',
  path: '/invoice-template/',
  getParentRoute: () => rootRoute,
} as any)

const appDashboardIndexRoute = appDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)

const publicPublicFeaturesRoute = publicPublicFeaturesImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicDocsRoute = publicPublicDocsImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => publicPublicRoute,
} as any)

const appDashboardTodosRoute = appDashboardTodosImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardSettingsRoute = appDashboardSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardInvoicesRoute = appDashboardInvoicesImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardTodosIndexRoute = appDashboardTodosIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardTodosRoute,
} as any)

const appDashboardTemplateCustomizerIndexRoute =
  appDashboardTemplateCustomizerIndexImport.update({
    id: '/template-customizer/',
    path: '/template-customizer/',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardShippingRatesIndexRoute =
  appDashboardShippingRatesIndexImport.update({
    id: '/shipping-rates/',
    path: '/shipping-rates/',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardSettingsIndexRoute = appDashboardSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardSettingsRoute,
} as any)

const appDashboardInvoicesIndexRoute = appDashboardInvoicesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardInvoicesRoute,
} as any)

const appDashboardInvoiceTemplateIndexRoute =
  appDashboardInvoiceTemplateIndexImport.update({
    id: '/invoice-template/',
    path: '/invoice-template/',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardCustomersIndexRoute = appDashboardCustomersIndexImport.update(
  {
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => appDashboardRoute,
  } as any,
)

const appDashboardCompanyDetailsIndexRoute =
  appDashboardCompanyDetailsIndexImport.update({
    id: '/company-details/',
    path: '/company-details/',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardSettingsInvoiceTemplatesLazyRoute =
  appDashboardSettingsInvoiceTemplatesLazyImport
    .update({
      id: '/invoice-templates',
      path: '/invoice-templates',
      getParentRoute: () => appDashboardSettingsRoute,
    } as any)
    .lazy(() =>
      import('./routes/(app)/dashboard/settings/invoice-templates.lazy').then(
        (d) => d.Route,
      ),
    )

const appDashboardTodosNewRoute = appDashboardTodosNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => appDashboardTodosRoute,
} as any)

const appDashboardSettingsUserProfileRoute =
  appDashboardSettingsUserProfileImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)

const appDashboardSettingsNumberSchemasRoute =
  appDashboardSettingsNumberSchemasImport
    .update({
      id: '/number-schemas',
      path: '/number-schemas',
      getParentRoute: () => appDashboardSettingsRoute,
    } as any)
    .lazy(() =>
      import('./routes/(app)/dashboard/settings/number-schemas.lazy').then(
        (d) => d.Route,
      ),
    )

const appDashboardSettingsChangePasswordRoute =
  appDashboardSettingsChangePasswordImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)

const appDashboardSettingsAppSettingsRoute =
  appDashboardSettingsAppSettingsImport.update({
    id: '/app-settings',
    path: '/app-settings',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)

const appDashboardInvoicesNewRoute = appDashboardInvoicesNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => appDashboardInvoicesRoute,
} as any)

const appDashboardCustomersNewRoute = appDashboardCustomersNewImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => appDashboardRoute,
} as any)

const appDashboardCustomersIdIndexRoute =
  appDashboardCustomersIdIndexImport.update({
    id: '/customers/$id/',
    path: '/customers/$id/',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardTodosEditIdRoute = appDashboardTodosEditIdImport.update({
  id: '/edit/$id',
  path: '/edit/$id',
  getParentRoute: () => appDashboardTodosRoute,
} as any)

const appDashboardTodosDetailIdRoute = appDashboardTodosDetailIdImport.update({
  id: '/detail/$id',
  path: '/detail/$id',
  getParentRoute: () => appDashboardTodosRoute,
} as any)

const appDashboardInvoicesEditIdRoute = appDashboardInvoicesEditIdImport.update(
  {
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => appDashboardInvoicesRoute,
  } as any,
)

const appDashboardInvoiceTemplateDesignerNewRoute =
  appDashboardInvoiceTemplateDesignerNewImport.update({
    id: '/invoice-template/designer/new',
    path: '/invoice-template/designer/new',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardInvoiceTemplateDesignerTemplateIdRoute =
  appDashboardInvoiceTemplateDesignerTemplateIdImport.update({
    id: '/invoice-template/designer/$templateId',
    path: '/invoice-template/designer/$templateId',
    getParentRoute: () => appDashboardRoute,
  } as any)

const appDashboardCustomersEditIdRoute =
  appDashboardCustomersEditIdImport.update({
    id: '/customers/edit/$id',
    path: '/customers/edit/$id',
    getParentRoute: () => appDashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterImport
      parentRoute: typeof rootRoute
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/(app)/dashboard/invoices': {
      id: '/(app)/dashboard/invoices'
      path: '/invoices'
      fullPath: '/dashboard/invoices'
      preLoaderRoute: typeof appDashboardInvoicesImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/settings': {
      id: '/(app)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof appDashboardSettingsImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/todos': {
      id: '/(app)/dashboard/todos'
      path: '/todos'
      fullPath: '/dashboard/todos'
      preLoaderRoute: typeof appDashboardTodosImport
      parentRoute: typeof appDashboardImport
    }
    '/(public)/_public/docs': {
      id: '/(public)/_public/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof publicPublicDocsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/features': {
      id: '/(public)/_public/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicPublicFeaturesImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/invoice-template/': {
      id: '/(app)/invoice-template/'
      path: '/invoice-template'
      fullPath: '/invoice-template'
      preLoaderRoute: typeof appInvoiceTemplateIndexImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/customers/new': {
      id: '/(app)/dashboard/customers/new'
      path: '/customers/new'
      fullPath: '/dashboard/customers/new'
      preLoaderRoute: typeof appDashboardCustomersNewImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoices/new': {
      id: '/(app)/dashboard/invoices/new'
      path: '/new'
      fullPath: '/dashboard/invoices/new'
      preLoaderRoute: typeof appDashboardInvoicesNewImport
      parentRoute: typeof appDashboardInvoicesImport
    }
    '/(app)/dashboard/settings/app-settings': {
      id: '/(app)/dashboard/settings/app-settings'
      path: '/app-settings'
      fullPath: '/dashboard/settings/app-settings'
      preLoaderRoute: typeof appDashboardSettingsAppSettingsImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/settings/change-password': {
      id: '/(app)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof appDashboardSettingsChangePasswordImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/settings/number-schemas': {
      id: '/(app)/dashboard/settings/number-schemas'
      path: '/number-schemas'
      fullPath: '/dashboard/settings/number-schemas'
      preLoaderRoute: typeof appDashboardSettingsNumberSchemasImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/settings/user-profile': {
      id: '/(app)/dashboard/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/settings/user-profile'
      preLoaderRoute: typeof appDashboardSettingsUserProfileImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/todos/new': {
      id: '/(app)/dashboard/todos/new'
      path: '/new'
      fullPath: '/dashboard/todos/new'
      preLoaderRoute: typeof appDashboardTodosNewImport
      parentRoute: typeof appDashboardTodosImport
    }
    '/(app)/dashboard/settings/invoice-templates': {
      id: '/(app)/dashboard/settings/invoice-templates'
      path: '/invoice-templates'
      fullPath: '/dashboard/settings/invoice-templates'
      preLoaderRoute: typeof appDashboardSettingsInvoiceTemplatesLazyImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/company-details/': {
      id: '/(app)/dashboard/company-details/'
      path: '/company-details'
      fullPath: '/dashboard/company-details'
      preLoaderRoute: typeof appDashboardCompanyDetailsIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/customers/': {
      id: '/(app)/dashboard/customers/'
      path: '/customers'
      fullPath: '/dashboard/customers'
      preLoaderRoute: typeof appDashboardCustomersIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoice-template/': {
      id: '/(app)/dashboard/invoice-template/'
      path: '/invoice-template'
      fullPath: '/dashboard/invoice-template'
      preLoaderRoute: typeof appDashboardInvoiceTemplateIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoices/': {
      id: '/(app)/dashboard/invoices/'
      path: '/'
      fullPath: '/dashboard/invoices/'
      preLoaderRoute: typeof appDashboardInvoicesIndexImport
      parentRoute: typeof appDashboardInvoicesImport
    }
    '/(app)/dashboard/settings/': {
      id: '/(app)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof appDashboardSettingsIndexImport
      parentRoute: typeof appDashboardSettingsImport
    }
    '/(app)/dashboard/shipping-rates/': {
      id: '/(app)/dashboard/shipping-rates/'
      path: '/shipping-rates'
      fullPath: '/dashboard/shipping-rates'
      preLoaderRoute: typeof appDashboardShippingRatesIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/template-customizer/': {
      id: '/(app)/dashboard/template-customizer/'
      path: '/template-customizer'
      fullPath: '/dashboard/template-customizer'
      preLoaderRoute: typeof appDashboardTemplateCustomizerIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/todos/': {
      id: '/(app)/dashboard/todos/'
      path: '/'
      fullPath: '/dashboard/todos/'
      preLoaderRoute: typeof appDashboardTodosIndexImport
      parentRoute: typeof appDashboardTodosImport
    }
    '/(app)/dashboard/customers/edit/$id': {
      id: '/(app)/dashboard/customers/edit/$id'
      path: '/customers/edit/$id'
      fullPath: '/dashboard/customers/edit/$id'
      preLoaderRoute: typeof appDashboardCustomersEditIdImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoice-template/designer/$templateId': {
      id: '/(app)/dashboard/invoice-template/designer/$templateId'
      path: '/invoice-template/designer/$templateId'
      fullPath: '/dashboard/invoice-template/designer/$templateId'
      preLoaderRoute: typeof appDashboardInvoiceTemplateDesignerTemplateIdImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoice-template/designer/new': {
      id: '/(app)/dashboard/invoice-template/designer/new'
      path: '/invoice-template/designer/new'
      fullPath: '/dashboard/invoice-template/designer/new'
      preLoaderRoute: typeof appDashboardInvoiceTemplateDesignerNewImport
      parentRoute: typeof appDashboardImport
    }
    '/(app)/dashboard/invoices/edit/$id': {
      id: '/(app)/dashboard/invoices/edit/$id'
      path: '/edit/$id'
      fullPath: '/dashboard/invoices/edit/$id'
      preLoaderRoute: typeof appDashboardInvoicesEditIdImport
      parentRoute: typeof appDashboardInvoicesImport
    }
    '/(app)/dashboard/todos/detail/$id': {
      id: '/(app)/dashboard/todos/detail/$id'
      path: '/detail/$id'
      fullPath: '/dashboard/todos/detail/$id'
      preLoaderRoute: typeof appDashboardTodosDetailIdImport
      parentRoute: typeof appDashboardTodosImport
    }
    '/(app)/dashboard/todos/edit/$id': {
      id: '/(app)/dashboard/todos/edit/$id'
      path: '/edit/$id'
      fullPath: '/dashboard/todos/edit/$id'
      preLoaderRoute: typeof appDashboardTodosEditIdImport
      parentRoute: typeof appDashboardTodosImport
    }
    '/(app)/dashboard/customers/$id/': {
      id: '/(app)/dashboard/customers/$id/'
      path: '/customers/$id'
      fullPath: '/dashboard/customers/$id'
      preLoaderRoute: typeof appDashboardCustomersIdIndexImport
      parentRoute: typeof appDashboardImport
    }
  }
}

// Create and export the route tree

interface appDashboardInvoicesRouteChildren {
  appDashboardInvoicesNewRoute: typeof appDashboardInvoicesNewRoute
  appDashboardInvoicesIndexRoute: typeof appDashboardInvoicesIndexRoute
  appDashboardInvoicesEditIdRoute: typeof appDashboardInvoicesEditIdRoute
}

const appDashboardInvoicesRouteChildren: appDashboardInvoicesRouteChildren = {
  appDashboardInvoicesNewRoute: appDashboardInvoicesNewRoute,
  appDashboardInvoicesIndexRoute: appDashboardInvoicesIndexRoute,
  appDashboardInvoicesEditIdRoute: appDashboardInvoicesEditIdRoute,
}

const appDashboardInvoicesRouteWithChildren =
  appDashboardInvoicesRoute._addFileChildren(appDashboardInvoicesRouteChildren)

interface appDashboardSettingsRouteChildren {
  appDashboardSettingsAppSettingsRoute: typeof appDashboardSettingsAppSettingsRoute
  appDashboardSettingsChangePasswordRoute: typeof appDashboardSettingsChangePasswordRoute
  appDashboardSettingsNumberSchemasRoute: typeof appDashboardSettingsNumberSchemasRoute
  appDashboardSettingsUserProfileRoute: typeof appDashboardSettingsUserProfileRoute
  appDashboardSettingsInvoiceTemplatesLazyRoute: typeof appDashboardSettingsInvoiceTemplatesLazyRoute
  appDashboardSettingsIndexRoute: typeof appDashboardSettingsIndexRoute
}

const appDashboardSettingsRouteChildren: appDashboardSettingsRouteChildren = {
  appDashboardSettingsAppSettingsRoute: appDashboardSettingsAppSettingsRoute,
  appDashboardSettingsChangePasswordRoute:
    appDashboardSettingsChangePasswordRoute,
  appDashboardSettingsNumberSchemasRoute:
    appDashboardSettingsNumberSchemasRoute,
  appDashboardSettingsUserProfileRoute: appDashboardSettingsUserProfileRoute,
  appDashboardSettingsInvoiceTemplatesLazyRoute:
    appDashboardSettingsInvoiceTemplatesLazyRoute,
  appDashboardSettingsIndexRoute: appDashboardSettingsIndexRoute,
}

const appDashboardSettingsRouteWithChildren =
  appDashboardSettingsRoute._addFileChildren(appDashboardSettingsRouteChildren)

interface appDashboardTodosRouteChildren {
  appDashboardTodosNewRoute: typeof appDashboardTodosNewRoute
  appDashboardTodosIndexRoute: typeof appDashboardTodosIndexRoute
  appDashboardTodosDetailIdRoute: typeof appDashboardTodosDetailIdRoute
  appDashboardTodosEditIdRoute: typeof appDashboardTodosEditIdRoute
}

const appDashboardTodosRouteChildren: appDashboardTodosRouteChildren = {
  appDashboardTodosNewRoute: appDashboardTodosNewRoute,
  appDashboardTodosIndexRoute: appDashboardTodosIndexRoute,
  appDashboardTodosDetailIdRoute: appDashboardTodosDetailIdRoute,
  appDashboardTodosEditIdRoute: appDashboardTodosEditIdRoute,
}

const appDashboardTodosRouteWithChildren =
  appDashboardTodosRoute._addFileChildren(appDashboardTodosRouteChildren)

interface appDashboardRouteChildren {
  appDashboardInvoicesRoute: typeof appDashboardInvoicesRouteWithChildren
  appDashboardSettingsRoute: typeof appDashboardSettingsRouteWithChildren
  appDashboardTodosRoute: typeof appDashboardTodosRouteWithChildren
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appDashboardCustomersNewRoute: typeof appDashboardCustomersNewRoute
  appDashboardCompanyDetailsIndexRoute: typeof appDashboardCompanyDetailsIndexRoute
  appDashboardCustomersIndexRoute: typeof appDashboardCustomersIndexRoute
  appDashboardInvoiceTemplateIndexRoute: typeof appDashboardInvoiceTemplateIndexRoute
  appDashboardShippingRatesIndexRoute: typeof appDashboardShippingRatesIndexRoute
  appDashboardTemplateCustomizerIndexRoute: typeof appDashboardTemplateCustomizerIndexRoute
  appDashboardCustomersEditIdRoute: typeof appDashboardCustomersEditIdRoute
  appDashboardInvoiceTemplateDesignerTemplateIdRoute: typeof appDashboardInvoiceTemplateDesignerTemplateIdRoute
  appDashboardInvoiceTemplateDesignerNewRoute: typeof appDashboardInvoiceTemplateDesignerNewRoute
  appDashboardCustomersIdIndexRoute: typeof appDashboardCustomersIdIndexRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardInvoicesRoute: appDashboardInvoicesRouteWithChildren,
  appDashboardSettingsRoute: appDashboardSettingsRouteWithChildren,
  appDashboardTodosRoute: appDashboardTodosRouteWithChildren,
  appDashboardIndexRoute: appDashboardIndexRoute,
  appDashboardCustomersNewRoute: appDashboardCustomersNewRoute,
  appDashboardCompanyDetailsIndexRoute: appDashboardCompanyDetailsIndexRoute,
  appDashboardCustomersIndexRoute: appDashboardCustomersIndexRoute,
  appDashboardInvoiceTemplateIndexRoute: appDashboardInvoiceTemplateIndexRoute,
  appDashboardShippingRatesIndexRoute: appDashboardShippingRatesIndexRoute,
  appDashboardTemplateCustomizerIndexRoute:
    appDashboardTemplateCustomizerIndexRoute,
  appDashboardCustomersEditIdRoute: appDashboardCustomersEditIdRoute,
  appDashboardInvoiceTemplateDesignerTemplateIdRoute:
    appDashboardInvoiceTemplateDesignerTemplateIdRoute,
  appDashboardInvoiceTemplateDesignerNewRoute:
    appDashboardInvoiceTemplateDesignerNewRoute,
  appDashboardCustomersIdIndexRoute: appDashboardCustomersIdIndexRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface publicPublicRouteChildren {
  publicPublicDocsRoute: typeof publicPublicDocsRoute
  publicPublicFeaturesRoute: typeof publicPublicFeaturesRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicDocsRoute: publicPublicDocsRoute,
  publicPublicFeaturesRoute: publicPublicFeaturesRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/dashboard': typeof appDashboardRouteWithChildren
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/invoices': typeof appDashboardInvoicesRouteWithChildren
  '/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/dashboard/todos': typeof appDashboardTodosRouteWithChildren
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/invoice-template': typeof appInvoiceTemplateIndexRoute
  '/dashboard/customers/new': typeof appDashboardCustomersNewRoute
  '/dashboard/invoices/new': typeof appDashboardInvoicesNewRoute
  '/dashboard/settings/app-settings': typeof appDashboardSettingsAppSettingsRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/number-schemas': typeof appDashboardSettingsNumberSchemasRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/dashboard/settings/invoice-templates': typeof appDashboardSettingsInvoiceTemplatesLazyRoute
  '/dashboard/company-details': typeof appDashboardCompanyDetailsIndexRoute
  '/dashboard/customers': typeof appDashboardCustomersIndexRoute
  '/dashboard/invoice-template': typeof appDashboardInvoiceTemplateIndexRoute
  '/dashboard/invoices/': typeof appDashboardInvoicesIndexRoute
  '/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/dashboard/shipping-rates': typeof appDashboardShippingRatesIndexRoute
  '/dashboard/template-customizer': typeof appDashboardTemplateCustomizerIndexRoute
  '/dashboard/todos/': typeof appDashboardTodosIndexRoute
  '/dashboard/customers/edit/$id': typeof appDashboardCustomersEditIdRoute
  '/dashboard/invoice-template/designer/$templateId': typeof appDashboardInvoiceTemplateDesignerTemplateIdRoute
  '/dashboard/invoice-template/designer/new': typeof appDashboardInvoiceTemplateDesignerNewRoute
  '/dashboard/invoices/edit/$id': typeof appDashboardInvoicesEditIdRoute
  '/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
  '/dashboard/customers/$id': typeof appDashboardCustomersIdIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/invoice-template': typeof appInvoiceTemplateIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/customers/new': typeof appDashboardCustomersNewRoute
  '/dashboard/invoices/new': typeof appDashboardInvoicesNewRoute
  '/dashboard/settings/app-settings': typeof appDashboardSettingsAppSettingsRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/number-schemas': typeof appDashboardSettingsNumberSchemasRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/dashboard/settings/invoice-templates': typeof appDashboardSettingsInvoiceTemplatesLazyRoute
  '/dashboard/company-details': typeof appDashboardCompanyDetailsIndexRoute
  '/dashboard/customers': typeof appDashboardCustomersIndexRoute
  '/dashboard/invoice-template': typeof appDashboardInvoiceTemplateIndexRoute
  '/dashboard/invoices': typeof appDashboardInvoicesIndexRoute
  '/dashboard/settings': typeof appDashboardSettingsIndexRoute
  '/dashboard/shipping-rates': typeof appDashboardShippingRatesIndexRoute
  '/dashboard/template-customizer': typeof appDashboardTemplateCustomizerIndexRoute
  '/dashboard/todos': typeof appDashboardTodosIndexRoute
  '/dashboard/customers/edit/$id': typeof appDashboardCustomersEditIdRoute
  '/dashboard/invoice-template/designer/$templateId': typeof appDashboardInvoiceTemplateDesignerTemplateIdRoute
  '/dashboard/invoice-template/designer/new': typeof appDashboardInvoiceTemplateDesignerNewRoute
  '/dashboard/invoices/edit/$id': typeof appDashboardInvoicesEditIdRoute
  '/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
  '/dashboard/customers/$id': typeof appDashboardCustomersIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(app)/dashboard/invoices': typeof appDashboardInvoicesRouteWithChildren
  '/(app)/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/(app)/dashboard/todos': typeof appDashboardTodosRouteWithChildren
  '/(public)/_public/docs': typeof publicPublicDocsRoute
  '/(public)/_public/features': typeof publicPublicFeaturesRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(app)/invoice-template/': typeof appInvoiceTemplateIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(app)/dashboard/customers/new': typeof appDashboardCustomersNewRoute
  '/(app)/dashboard/invoices/new': typeof appDashboardInvoicesNewRoute
  '/(app)/dashboard/settings/app-settings': typeof appDashboardSettingsAppSettingsRoute
  '/(app)/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/(app)/dashboard/settings/number-schemas': typeof appDashboardSettingsNumberSchemasRoute
  '/(app)/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/(app)/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/(app)/dashboard/settings/invoice-templates': typeof appDashboardSettingsInvoiceTemplatesLazyRoute
  '/(app)/dashboard/company-details/': typeof appDashboardCompanyDetailsIndexRoute
  '/(app)/dashboard/customers/': typeof appDashboardCustomersIndexRoute
  '/(app)/dashboard/invoice-template/': typeof appDashboardInvoiceTemplateIndexRoute
  '/(app)/dashboard/invoices/': typeof appDashboardInvoicesIndexRoute
  '/(app)/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/(app)/dashboard/shipping-rates/': typeof appDashboardShippingRatesIndexRoute
  '/(app)/dashboard/template-customizer/': typeof appDashboardTemplateCustomizerIndexRoute
  '/(app)/dashboard/todos/': typeof appDashboardTodosIndexRoute
  '/(app)/dashboard/customers/edit/$id': typeof appDashboardCustomersEditIdRoute
  '/(app)/dashboard/invoice-template/designer/$templateId': typeof appDashboardInvoiceTemplateDesignerTemplateIdRoute
  '/(app)/dashboard/invoice-template/designer/new': typeof appDashboardInvoiceTemplateDesignerNewRoute
  '/(app)/dashboard/invoices/edit/$id': typeof appDashboardInvoicesEditIdRoute
  '/(app)/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/(app)/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
  '/(app)/dashboard/customers/$id/': typeof appDashboardCustomersIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/login'
    | '/register'
    | '/'
    | '/dashboard/invoices'
    | '/dashboard/settings'
    | '/dashboard/todos'
    | '/docs'
    | '/features'
    | '/dashboard/'
    | '/invoice-template'
    | '/dashboard/customers/new'
    | '/dashboard/invoices/new'
    | '/dashboard/settings/app-settings'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/number-schemas'
    | '/dashboard/settings/user-profile'
    | '/dashboard/todos/new'
    | '/dashboard/settings/invoice-templates'
    | '/dashboard/company-details'
    | '/dashboard/customers'
    | '/dashboard/invoice-template'
    | '/dashboard/invoices/'
    | '/dashboard/settings/'
    | '/dashboard/shipping-rates'
    | '/dashboard/template-customizer'
    | '/dashboard/todos/'
    | '/dashboard/customers/edit/$id'
    | '/dashboard/invoice-template/designer/$templateId'
    | '/dashboard/invoice-template/designer/new'
    | '/dashboard/invoices/edit/$id'
    | '/dashboard/todos/detail/$id'
    | '/dashboard/todos/edit/$id'
    | '/dashboard/customers/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/docs'
    | '/features'
    | '/dashboard'
    | '/invoice-template'
    | '/'
    | '/dashboard/customers/new'
    | '/dashboard/invoices/new'
    | '/dashboard/settings/app-settings'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/number-schemas'
    | '/dashboard/settings/user-profile'
    | '/dashboard/todos/new'
    | '/dashboard/settings/invoice-templates'
    | '/dashboard/company-details'
    | '/dashboard/customers'
    | '/dashboard/invoice-template'
    | '/dashboard/invoices'
    | '/dashboard/settings'
    | '/dashboard/shipping-rates'
    | '/dashboard/template-customizer'
    | '/dashboard/todos'
    | '/dashboard/customers/edit/$id'
    | '/dashboard/invoice-template/designer/$templateId'
    | '/dashboard/invoice-template/designer/new'
    | '/dashboard/invoices/edit/$id'
    | '/dashboard/todos/detail/$id'
    | '/dashboard/todos/edit/$id'
    | '/dashboard/customers/$id'
  id:
    | '__root__'
    | '/(app)/dashboard'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(public)'
    | '/(public)/_public'
    | '/(app)/dashboard/invoices'
    | '/(app)/dashboard/settings'
    | '/(app)/dashboard/todos'
    | '/(public)/_public/docs'
    | '/(public)/_public/features'
    | '/(app)/dashboard/'
    | '/(app)/invoice-template/'
    | '/(public)/_public/'
    | '/(app)/dashboard/customers/new'
    | '/(app)/dashboard/invoices/new'
    | '/(app)/dashboard/settings/app-settings'
    | '/(app)/dashboard/settings/change-password'
    | '/(app)/dashboard/settings/number-schemas'
    | '/(app)/dashboard/settings/user-profile'
    | '/(app)/dashboard/todos/new'
    | '/(app)/dashboard/settings/invoice-templates'
    | '/(app)/dashboard/company-details/'
    | '/(app)/dashboard/customers/'
    | '/(app)/dashboard/invoice-template/'
    | '/(app)/dashboard/invoices/'
    | '/(app)/dashboard/settings/'
    | '/(app)/dashboard/shipping-rates/'
    | '/(app)/dashboard/template-customizer/'
    | '/(app)/dashboard/todos/'
    | '/(app)/dashboard/customers/edit/$id'
    | '/(app)/dashboard/invoice-template/designer/$templateId'
    | '/(app)/dashboard/invoice-template/designer/new'
    | '/(app)/dashboard/invoices/edit/$id'
    | '/(app)/dashboard/todos/detail/$id'
    | '/(app)/dashboard/todos/edit/$id'
    | '/(app)/dashboard/customers/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appDashboardRoute: typeof appDashboardRouteWithChildren
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  publicRoute: typeof publicRouteWithChildren
  appInvoiceTemplateIndexRoute: typeof appInvoiceTemplateIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  appDashboardRoute: appDashboardRouteWithChildren,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  publicRoute: publicRouteWithChildren,
  appInvoiceTemplateIndexRoute: appInvoiceTemplateIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)/dashboard",
        "/(auth)/login",
        "/(auth)/register",
        "/(public)",
        "/(app)/invoice-template/"
      ]
    },
    "/(app)/dashboard": {
      "filePath": "(app)/dashboard.tsx",
      "children": [
        "/(app)/dashboard/invoices",
        "/(app)/dashboard/settings",
        "/(app)/dashboard/todos",
        "/(app)/dashboard/",
        "/(app)/dashboard/customers/new",
        "/(app)/dashboard/company-details/",
        "/(app)/dashboard/customers/",
        "/(app)/dashboard/invoice-template/",
        "/(app)/dashboard/shipping-rates/",
        "/(app)/dashboard/template-customizer/",
        "/(app)/dashboard/customers/edit/$id",
        "/(app)/dashboard/invoice-template/designer/$templateId",
        "/(app)/dashboard/invoice-template/designer/new",
        "/(app)/dashboard/customers/$id/"
      ]
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/(auth)/register": {
      "filePath": "(auth)/register.tsx"
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/docs",
        "/(public)/_public/features",
        "/(public)/_public/"
      ]
    },
    "/(app)/dashboard/invoices": {
      "filePath": "(app)/dashboard/invoices.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/invoices/new",
        "/(app)/dashboard/invoices/",
        "/(app)/dashboard/invoices/edit/$id"
      ]
    },
    "/(app)/dashboard/settings": {
      "filePath": "(app)/dashboard/settings.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/settings/app-settings",
        "/(app)/dashboard/settings/change-password",
        "/(app)/dashboard/settings/number-schemas",
        "/(app)/dashboard/settings/user-profile",
        "/(app)/dashboard/settings/invoice-templates",
        "/(app)/dashboard/settings/"
      ]
    },
    "/(app)/dashboard/todos": {
      "filePath": "(app)/dashboard/todos.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/todos/new",
        "/(app)/dashboard/todos/",
        "/(app)/dashboard/todos/detail/$id",
        "/(app)/dashboard/todos/edit/$id"
      ]
    },
    "/(public)/_public/docs": {
      "filePath": "(public)/_public/docs.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/features": {
      "filePath": "(public)/_public/features.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/": {
      "filePath": "(app)/dashboard/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/invoice-template/": {
      "filePath": "(app)/invoice-template/index.tsx"
    },
    "/(public)/_public/": {
      "filePath": "(public)/_public/index.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/customers/new": {
      "filePath": "(app)/dashboard/customers/new.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoices/new": {
      "filePath": "(app)/dashboard/invoices/new.tsx",
      "parent": "/(app)/dashboard/invoices"
    },
    "/(app)/dashboard/settings/app-settings": {
      "filePath": "(app)/dashboard/settings/app-settings.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/settings/change-password": {
      "filePath": "(app)/dashboard/settings/change-password.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/settings/number-schemas": {
      "filePath": "(app)/dashboard/settings/number-schemas.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/settings/user-profile": {
      "filePath": "(app)/dashboard/settings/user-profile.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/todos/new": {
      "filePath": "(app)/dashboard/todos/new.tsx",
      "parent": "/(app)/dashboard/todos"
    },
    "/(app)/dashboard/settings/invoice-templates": {
      "filePath": "(app)/dashboard/settings/invoice-templates.lazy.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/company-details/": {
      "filePath": "(app)/dashboard/company-details/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/customers/": {
      "filePath": "(app)/dashboard/customers/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoice-template/": {
      "filePath": "(app)/dashboard/invoice-template/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoices/": {
      "filePath": "(app)/dashboard/invoices/index.tsx",
      "parent": "/(app)/dashboard/invoices"
    },
    "/(app)/dashboard/settings/": {
      "filePath": "(app)/dashboard/settings/index.tsx",
      "parent": "/(app)/dashboard/settings"
    },
    "/(app)/dashboard/shipping-rates/": {
      "filePath": "(app)/dashboard/shipping-rates/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/template-customizer/": {
      "filePath": "(app)/dashboard/template-customizer/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/todos/": {
      "filePath": "(app)/dashboard/todos/index.tsx",
      "parent": "/(app)/dashboard/todos"
    },
    "/(app)/dashboard/customers/edit/$id": {
      "filePath": "(app)/dashboard/customers/edit/$id.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoice-template/designer/$templateId": {
      "filePath": "(app)/dashboard/invoice-template/designer.$templateId.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoice-template/designer/new": {
      "filePath": "(app)/dashboard/invoice-template/designer.new.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/invoices/edit/$id": {
      "filePath": "(app)/dashboard/invoices/edit/$id.tsx",
      "parent": "/(app)/dashboard/invoices"
    },
    "/(app)/dashboard/todos/detail/$id": {
      "filePath": "(app)/dashboard/todos/detail/$id.tsx",
      "parent": "/(app)/dashboard/todos"
    },
    "/(app)/dashboard/todos/edit/$id": {
      "filePath": "(app)/dashboard/todos/edit/$id.tsx",
      "parent": "/(app)/dashboard/todos"
    },
    "/(app)/dashboard/customers/$id/": {
      "filePath": "(app)/dashboard/customers/$id/index.tsx",
      "parent": "/(app)/dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
